module.exports = __webpack_public_path__ + "media/logo/logo-home-a2f729ec.svg";